import BaseModel from "./../base/baseModel";

export default class ModeloImpressaoCondicaoModel extends BaseModel {
    id?: number = null;
    modeloImpressaoId?: number = null;
    condicaoCampoName: string = null;
    condicaoCampoPath: string = null;
    condicaoValue: string = null;
}
